"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOilon = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.calculateOilon = (0, graphql_tag_1.default) `
  query CalculateOilon($input: OilonCalculationInputType!) {
    user {
      calculateOilon(input: $input) {
        hasResult
        oilonId
        errors
        calculationCases {
          name
          cop
          wetAirCapacityRequired
          wetAirDumpingStreamFlow
          highTemperatureStageCop
          highTemperatureStageHeatingCapacity
          highTemperatureStageElectricPowerConsumed
          highTemperatureStageLiquidOutletTemperature
          highTemperatureStageRelativeCapacity
          highTemperatureStageRelativeCapacityAtMinimumSpeed
          highTemperatureStageCondenserFlowRate
          highTemperatureStageCirculationPumpPower
          lowTemperatureStageCop
          lowTemperatureStageHeatingCapacity
          lowTemperatureStageElectricPowerConsumed
          lowTemperatureStageCondenserLiquidOutletTemperature
          lowTemperatureStageRelativeCapacity
          lowTemperatureStageRelativeCapacityAtMinimumSpeed
          lowTemperatureStageCondenserFlowRate
          lowTemperatureStageCirculationPumpPower
          lowTemperatureStageCoolingCapacity
          lowTemperatureStageEvaporatorLiquidOutletTemperature
          lowTemperatureStageEvaporatorFlowRate
        }
      }
    }
  }
`;
//# sourceMappingURL=queries.js.map